import React, { useEffect, useState } from "react";
import { Button, Form } from "react-bootstrap";

const ScheduleUnexcusedAbsenceForm = ({ employeeId, date, supervisors, onSave, onCancel, saving }) => {
  const [form, setForm] = useState({
    supervisorID: "",
    comments: ""
  });

  useEffect(() => {
    setForm({ supervisorID: "", comments: "" });
  }, [employeeId, date]);

  const submit = async event => {
    event.preventDefault();
    const saved = await onSave({
      EID: Number(employeeId),
      dateFrom: date,
      dateTo: date,
      comments: form.comments,
      supervisorID: Number(form.supervisorID)
    });
    if (saved) onCancel();
  };

  return (
    <Form onSubmit={submit} className="schedule-quick-form">
      <div className="schedule-unexcused-info">
        Nieobecność nieusprawiedliwiona zostanie zapisana na dzień <b>{date}</b>.
      </div>
      <Form.Group>
        <Form.Label>Osoba zatwierdzająca</Form.Label>
        <Form.Select value={form.supervisorID} onChange={event => setForm(current => ({ ...current, supervisorID: event.target.value }))} required>
          <option value="">Wybierz osobę</option>
          {(supervisors ?? []).map(supervisor => <option key={supervisor.id} value={supervisor.id}>{supervisor.fullName}</option>)}
        </Form.Select>
      </Form.Group>
      <Form.Group>
        <Form.Label>Uwagi</Form.Label>
        <Form.Control as="textarea" rows={2} value={form.comments} onChange={event => setForm(current => ({ ...current, comments: event.target.value }))} />
      </Form.Group>
      <div className="schedule-form-actions mt-3">
        <Button type="submit" variant="danger" disabled={saving}>Oznacz nieusprawiedliwioną</Button>
        <Button type="button" variant="secondary" onClick={onCancel} disabled={saving}>Anuluj</Button>
      </div>
    </Form>
  );
};

export default ScheduleUnexcusedAbsenceForm;
